import * as types from './constants';

// Edit Code
export const editCodeRequest = data => (
  { type: types.EDIT_CODE_REQUEST, payload: data }
);

export const editCodeDone = data => (
  { type: types.EDIT_CODE_DONE, payload: data }
);

export const editCodeFailed = errors => (
  { type: types.EDIT_CODE_FAILED, payload: errors }
);

export const editCodeReset = () => (
  { type: types.EDIT_CODE_RESET }
);